import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, of } from 'rxjs';
import { User } from '../authentication/user';
import { SettingsFormGroup } from '../../pages/account/settings-form-group';
import { MainRoutes } from '../../pages/main-routes.enum';

/**
 * Redirects the user to the {@link AccountPage} if the (default) settings of the {@link User}
 * are not valid to use the application. Depending on the {@link Role}s of the user, different
 * validation rules are applicable.
 */
export const SettingsGuard: CanActivateFn = (route, state) => {
  if (state.url === MainRoutes.ACCOUNT || state.url === MainRoutes.DRIVER_NAME || state.url === MainRoutes.LOGOUT) {
    return of(true);
  }

  const router = inject(Router);
  const userService = inject(UserService);
  return toObservable(userService.isInitialized).pipe(
    filter(Boolean),
    map(() => {
      const user = userService.user()!;
      if (!user.hasHandoverRole() && !user.hasDriverRole()) {
        return true;
      }

      const settingsFormGroup = new SettingsFormGroup(userService.settings()!, user.roles);
      if (settingsFormGroup.valid) {
        return true;
      }

      router.navigate([MainRoutes.ACCOUNT]);
      return false;
    })
  );
};
